// oxlint-disable require-await
import {dialog} from '@cypro/ui/components'
import {DeleteResourceDialog} from '@cypro/ui/components'
import {useZero} from '@/shared/integrations/zero/use-zero'
import {DeleteResourceSchema} from '@cypro/engine/mutators/util'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'

export function useDeleteConsumable() {
  const zero = useZero()

  return useCallback(
    async (payload: DeleteResourceSchema) =>
      zero.attemptMutation(zero.mutators.consumables.delete(payload), async mutation => await mutation.server),
    [zero]
  )
}

export function useConfirmDeleteConsumable() {
  const {t: tConsumables} = useTranslate('consumables')
  const deleteConsumable = useDeleteConsumable()

  return useCallback(
    async (payload: DeleteResourceSchema) => {
      const confirmed = await dialog.open(payload.id, {
        children: (
          <DeleteResourceDialog
            id={payload.id}
            title={tConsumables('delete_consumable_dialog.title')}
            description={tConsumables('delete_consumable_dialog.description')}
          />
        ),
      })
      if (!confirmed) throw new Error('User did not confirm')

      const deleteRes = await deleteConsumable(payload)
      if (!deleteRes) throw new Error('Unexpected error')
      if (deleteRes.type === 'error') throw deleteRes.error
    },
    [tConsumables, deleteConsumable]
  )
}
